import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuBujumbura'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';

const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));
const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const ntahangwaData = {
  title: "REPARTITION DE LA POPULATION DES MENAGES ORDINAIRES PAR COLLINE, ZONE ET COMMUNE",
  province: {
    id: "1",
    name: "BUHUMUZA",
    commune: {
      id: "106",
      name: "NTAHANGWA",
      total: 912865,
      zones: [
        {
          id: "10601",
          name: "BENGA",
          total: 28614,
          collines: [
            { id: "10601101", name: "KWIGERE", population: 9795 },
            { id: "10601102", name: "BENGA", population: 11993 },
            { id: "10601103", name: "KARUNGA", population: 6826 }
          ]
        },
        {
          id: "10602",
          name: "BUTERERE",
          total: 118253,
          collines: [
            { id: "10602101", name: "QUARTIER MWEZI", population: 32630 },
            { id: "10602102", name: "QUARTIER BUMWE", population: 27783 },
            { id: "10602103", name: "QUARTIER MUHUZA", population: 15621 },
            { id: "10602104", name: "QUARTIER MUGARURO", population: 12406 },
            { id: "10602105", name: "QUARTIER KABUSA", population: 9908 },
            { id: "10602106", name: "QUARTIER MUBONE", population: 7609 },
            { id: "10602107", name: "QUARTIER KIYANGE", population: 6924 },
            { id: "10602108", name: "QUARTIER MWIZERO", population: 5372 }
          ]
        },
        {
          id: "10603",
          name: "CIBITOKE",
          total: 68178,
          collines: [
            { id: "10603101", name: "QUARTIER MUTAKURA", population: 16537 },
            { id: "10603102", name: "QUARTIER NYAMWIZA", population: 13841 },
            { id: "10603103", name: "QUARTIER MAHORO", population: 5518 },
            { id: "10603104", name: "QUARTIER MUHUZA", population: 9049 },
            { id: "10603105", name: "QUARTIER BUHURIRO", population: 9515 },
            { id: "10603106", name: "QUARTIER HUMURIZA", population: 8508 },
            { id: "10603107", name: "QUARTIER MWIZERO", population: 5210 }
          ]
        },
        {
          id: "10604",
          name: "GATUMBA",
          total: 32704,
          collines: [
            { id: "10604101", name: "QUARTIER GAHARAWE", population: 4826 },
            { id: "10604102", name: "QUARTIER RUSIZI", population: 4639 },
            { id: "10604103", name: "QUARTIER WARUBONDO", population: 4498 },
            { id: "10604104", name: "QUARTIER MAHOTERA", population: 3698 },
            { id: "10604105", name: "QUARTIER MURINZI", population: 4016 },
            { id: "10604106", name: "QUARTIER CUHIRO", population: 4468 },
            { id: "10604107", name: "QUARTIER KEZA", population: 4295 },
            { id: "10604108", name: "QUARTIER MUSHASHA", population: 1087 },
            { id: "10604109", name: "QUARTIER VUGIZO", population: 1177 }
          ]
        },
        {
          id: "10605",
          name: "GIHOSHA",
          total: 99284,
          collines: [
            { id: "10605101", name: "QUARTIER NYABAGERE", population: 23986 },
            { id: "10605102", name: "QUARTIER MUYAGA", population: 20239 },
            { id: "10605103", name: "QUARTIER SANGWE", population: 21484 },
            { id: "10605104", name: "QUARTIER KIGOBE", population: 8323 },
            { id: "10605105", name: "QUARTIER WINTEREKWA", population: 10189 },
            { id: "10605106", name: "QUARTIER TABA", population: 6267 },
            { id: "10605107", name: "QUARTIER HURIRO", population: 3361 },
            { id: "10605108", name: "QUARTIER GITARE", population: 2814 },
            { id: "10605109", name: "QUARTIER SANGANIRO", population: 2621 }
          ]
        },
        {
          id: "10606",
          name: "KAMENGE",
          total: 95632,
          collines: [
            { id: "10606101", name: "QUARTIER MUKOZI", population: 34330 },
            { id: "10606102", name: "QUARTIER MIRANGO", population: 25282 },
            { id: "10606103", name: "QUARTIER GITURO", population: 5718 },
            { id: "10606104", name: "QUARTIER GIKIZI", population: 5253 },
            { id: "10606105", name: "QUARTIER SONGA", population: 4814 },
            { id: "10606106", name: "QUARTIER TWINYONI", population: 4237 },
            { id: "10606107", name: "QUARTIER HEHA", population: 4990 },
            { id: "10606108", name: "QUARTIER TEZA", population: 4854 },
            { id: "10606109", name: "QUARTIER KAVUMU", population: 5407 },
            { id: "10606110", name: "QUARTIER TWIZERANE", population: 747 }
          ]
        },
        {
          id: "10607",
          name: "KINAMA",
          total: 137808,
          collines: [
            { id: "10607101", name: "QUARTIER CARAMA", population: 33334 },
            { id: "10607102", name: "QUARTIER NGOZI", population: 8402 },
            { id: "10607103", name: "QUARTIER MUCO", population: 16827 },
            { id: "10607104", name: "QUARTIER BUBANZA", population: 13850 },
            { id: "10607105", name: "QUARTIER MUTAGA", population: 14550 },
            { id: "10607106", name: "QUARTIER BUHINYUZA", population: 11408 },
            { id: "10607107", name: "QUARTIER GITEGA", population: 10544 },
            { id: "10607108", name: "QUARTIER RUYIGI", population: 4441 },
            { id: "10607109", name: "QUARTIER BURURI", population: 4212 },
            { id: "10607110", name: "QUARTIER KANGA", population: 5962 },
            { id: "10607111", name: "QUARTIER MURAMVYA", population: 6663 },
            { id: "10607112", name: "QUARTIER MUYINGA", population: 7615 }
          ]
        },
        {
          id: "10608",
          name: "KIREKURA",
          total: 13740,
          collines: [
            { id: "10608101", name: "MIKANGARA", population: 6186 },
            { id: "10608102", name: "NYARUHAMA", population: 3646 },
            { id: "10608103", name: "BUDAHIRWA", population: 2522 },
            { id: "10608104", name: "KIVOGERO", population: 809 },
            { id: "10608105", name: "BUGOMA", population: 577 }
          ]
        },
        {
          id: "10609",
          name: "MUTIMBUZI",
          total: 63592,
          collines: [
            { id: "10609101", name: "QUARTIER MUZAZI", population: 19065 },
            { id: "10609102", name: "QUARTIER BUHOMBA", population: 11073 },
            { id: "10609103", name: "QUARTIER MUGIRIGIRI", population: 12208 },
            { id: "10609104", name: "QUARTIER BIGWATI", population: 7436 },
            { id: "10609105", name: "QUARTIER MUTIMBUZI", population: 6636 },
            { id: "10609106", name: "QUARTIER SAMARIRO", population: 5850 },
            { id: "10609107", name: "QUARTIER MASANGANZIRA", population: 1324 }
          ]
        },
        {
          id: "10610",
          name: "NGAGARA",
          total: 34427,
          collines: [
            { id: "10610101", name: "QUARTIER NGAGARA", population: 10353 },
            { id: "10610102", name: "QUARTIER MAHINGURIRO", population: 3007 },
            { id: "10610103", name: "QUARTIER RUKUNDO", population: 3961 },
            { id: "10610104", name: "QUARTIER MAJAMBERE", population: 2537 },
            { id: "10610105", name: "QUARTIER GATEKA", population: 3419 },
            { id: "10610106", name: "QUARTIER MUHINGA", population: 3331 },
            { id: "10610107", name: "QUARTIER MUHIZI", population: 3491 },
            { id: "10610108", name: "QUARTIER MUBANO", population: 2950 },
            { id: "10610109", name: "QUARTIER MUGISHA", population: 1378 }
          ]
        },
        {
          id: "10611",
          name: "NYAMBUYE",
          total: 33773,
          collines: [
            { id: "10611101", name: "GISHINGANO", population: 15842 },
            { id: "10611102", name: "NYAMBUYE", population: 11303 },
            { id: "10611103", name: "NYAKIBANDE", population: 6628 }
          ]
        },
        {
          id: "10612",
          name: "RUBIRIZI",
          total: 163779,
          collines: [
            { id: "10612101", name: "GATUNGURU", population: 32949 },
            { id: "10612102", name: "TENGA", population: 24887 },
            { id: "10612103", name: "GAHAHE", population: 24869 },
            { id: "10612104", name: "RUBIRIZI", population: 21761 },
            { id: "10612105", name: "GASENYI", population: 20763 },
            { id: "10612106", name: "KARAMA", population: 14569 },
            { id: "10612107", name: "NYABUNYEGERI", population: 11380 },
            { id: "10612108", name: "GAHWAMA", population: 7493 },
            { id: "10612109", name: "MUYANGE", population: 5108 }
          ]
        },
        {
          id: "10613",
          name: "RUKARAMU",
          total: 23081,
          collines: [
            { id: "10613101", name: "QUARTIER KINYINYA", population: 6038 },
            { id: "10613102", name: "QUARTIER GAKUMBU", population: 5690 },
            { id: "10613103", name: "QUARTIER KAJAGA", population: 5099 },
            { id: "10613104", name: "QUARTIER RUVYAGIRA", population: 4454 },
            { id: "10613105", name: "QUARTIER KAGERA", population: 1800 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageBujumburaNtahangwa = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(ntahangwaData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = ntahangwaData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info NTAHANGWA
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {ntahangwaData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de NTAHANGWA`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de NTAHANGWA
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                     
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE DE NTAHANGWA</TableCell>
                          <TableCell align="right">{ntahangwaData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de NTAHANGWA
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de NTAHANGWA est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de NTAHANGWA ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
         <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageBujumburaNtahangwa;